__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "@fsa/servicejob-management";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@asurion-core/mx-asurion-ui-react", "4.64.8", () => (() => (__webpack_require__(47576))), 1);
			register("@reduxjs/toolkit", "2.12.0", () => (() => (__webpack_require__(20038))), 1);
			register("@reduxjs/toolkit", "2.12.0", () => (() => (__webpack_require__(64757))), 1);
			register("react-dom", "18.3.1", () => (() => (__webpack_require__(43144))), 1);
			register("react-redux", "7.2.9", () => (() => (__webpack_require__(54057))), 1);
			register("react-redux", "8.1.3", () => (() => (__webpack_require__(20759))), 1);
			register("react-redux", "9.3.0", () => (() => (__webpack_require__(71468))), 1);
			register("react-router-dom", "6.30.4", () => (() => (__webpack_require__(39723))), 1);
			register("react-router-dom", "6.30.4", () => (() => (__webpack_require__(84976))), 1);
			register("react-router-dom", "6.30.4", () => (() => (__webpack_require__(73657))), 1);
			register("react/jsx-runtime", "18.3.1", () => (() => (__webpack_require__(31085))), 1);
			register("react", "18.3.1", () => (() => (__webpack_require__(14041))), 1);
			initExternal(77995);
			initExternal(78145);
			initExternal(33407);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};